import styled from "styled-components";
const Wrapper = styled.div`
  width: 100%;
  min-height: 140px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;    
  background-color: #6DA6A8;
  border-radius: 8px;
  background-image: url("/wp-content/uploads/2023/09/icon-eur-pointer.png");
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: 98%;
  background-size: 122px 94px;
  
  .text-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  .text {
    color: #fff;
    font-size: 21px;
    font-weight: 700;
  }
`;
export default function ConfigurateurHeaderContainer({mode}) {
    return (
        <Wrapper className={mode ? 'hidden' : ''}>
            <div className="text-container">
                <img src={"/wp-content/uploads/2023/09/icon-customize.svg"}  alt="Ma découpe"/>
                <span className="text">Personnalisez votre découpe ou votre pliage et obtenez un prix en quelques clics !</span>
            </div>
        </Wrapper>
    );
};